import {firstOrUndefined} from "@ots-frontend/ots-data";
import {InsightEmpty} from "../InsightEmpty/InsightEmpty";
import {InsightLineChart, InsightLineChartProps} from "../InsightLineChart/InsightLineChart";
import {StatisticTypeSelect} from "../../select/entity/StatisticTypeSelect/StatisticTypeSelect";
import {Center, Stack} from "@mantine/core";
import {ByTimeInsightProps} from "./ByTimeInsight";
import {useByTimeInsight} from "./useByTimeInsight";
import {PropsWithChildren} from "react";
import {InsightTimeChart} from "../InsightTimeChart/InsightTimeChart";

export type LineByTimeInsightProps =
  Pick<InsightLineChartProps, 'tooltipPos' | 'stacked' | 'containerProps' | 'loading'>
  & ByTimeInsightProps

export const LineByTimeInsight = (props: PropsWithChildren<LineByTimeInsightProps>) => {
  const {
    title,
    fromDttm,
    toDttm = new Date().getTime(),
    data,
    methods,
    splitMethod = true,
    statisticsTypes,
    category,
    showSelect = true,
    showEmpty = true,
    children,
    ...rest
  } = props

  const {
    chartData,
    types,
    statisticType,
    setStatisticType
  } = useByTimeInsight({
    fromDttm,
    toDttm,
    data,
    methods,
    splitMethod,
    statisticsTypes,
    category,
  })

  if (showEmpty && (!chartData || chartData.titles.length === 0)) {
    return <InsightEmpty {...rest} title={title}/>
  }

  return (
    <InsightTimeChart
      {...rest}
      title={title}
      data={chartData}>
      {((showSelect && types.length > 1) || children) &&
        <Stack>
          {(showSelect && types.length > 1) &&
            <Center>
              <StatisticTypeSelect
                w={"250px"}
                placeholder={"Type"}
                defaultValue={statisticType}
                options={types}
                onDbCodeChange={c => setStatisticType(firstOrUndefined(c))}/>
            </Center>
          }
          {children}
        </Stack>
      }
    </InsightTimeChart>
  )
}
